import styled from "styled-components/macro";
import {themecolors} from "../utils/themecolors";

const Select = styled.div``;
const Selected = styled.div``;

const FileUpload = styled(({className, onChange, selectedFile}) => {

    const triggerFileInput = () => {
        document.getElementById("fileInput").click();
    };

    return (
        <div className={className}>
            <Select onClick={triggerFileInput}>Select a File</Select>
            <input style={{display: 'none'}} id={'fileInput'} type={"file"} onChange={onChange}/>
            <Selected>{selectedFile && selectedFile.name}</Selected>
        </div>
    )
})`
  ${Select} {
    cursor: pointer;
    border: 1px solid ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_6 : themecolors.light_border};
    font-size: 14px;
    border-radius: 4px;
    width: 116px;
    padding: 6px 16px;
    text-align: center;
  }

  ${Selected} {
    margin-top: 6px;
    font-size: 15px;
  }

`;

export default FileUpload;
